// Import the functions you need from the SDKs you need
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable, HttpsCallableResult} from "firebase/functions";
import { getStorage } from "firebase/storage";
// import { arrayBufferToBase64 } from "./util";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import {
  getAuth
} from 'firebase/auth';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// const firebaseConfig = {
//   apiKey: "AIzaSyBzMy3Jw1QGhBPP5dQ1VTeelSuXkwb15bA",
//   authDomain: "remotion-983bf.firebaseapp.com",
//   databaseURL: "https://remotion-983bf-default-rtdb.firebaseio.com",
//   projectId: "remotion-983bf",
//   storageBucket: "remotion-983bf.appspot.com",
//   messagingSenderId: "132409707055",
//   appId: "1:132409707055:web:85dc0f732329189dba54da",
//   measurementId: "G-FWBP2WJVSS"
// };

const firebaseConfig = {
  apiKey: "AIzaSyAzlrnxUvjQBnhNoXSqDks-b4JuDsgUHfI",
  authDomain: "aivideo-ef21f.firebaseapp.com",
  projectId: "aivideo-ef21f",
  storageBucket: "aivideo-ef21f.appspot.com",
  messagingSenderId: "444322749450",
  appId: "1:444322749450:web:562944aedff68180e9d3f3",
  measurementId: "G-TB9YNMYD11"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const firebaseStorage = getStorage(app);
export const firebaseFunctions = getFunctions(app);
export const firebaseAuth = getAuth(app)
export const firebaseHTTPSCallable = (name) => httpsCallable(firebaseFunctions, name)
export const generateAudioEleven = firebaseHTTPSCallable('generateAudioEleven') as (data: unknown) => Promise<HttpsCallableResult<any>>
export const getVideo = firebaseHTTPSCallable('getVideo') as (data: unknown) => Promise<HttpsCallableResult<any>>